export enum SegmentType {
    NEW = 'NEW',
}
